<!-- Quatro KPIs na ordem do protótipo 01: patrimônio, dívidas, renda que sobra e capacidade livre de garantia. -->
<section class="pit-row" aria-label="Indicadores do sócio">
  <div class="pit-kpi">
    <p class="pit-kpi__label">Patrimônio líquido declarado</p>
    <p class="pit-kpi__value">{{ money(indicators().netWorth) }}</p>
    @if (netWorthNote()) {
      <p
        class="pit-kpi__note"
        [class.pit-positive]="tone(indicators().netWorthYoY) === 'positive'"
        [class.pit-negative]="tone(indicators().netWorthYoY) === 'negative'">
        {{ netWorthNote() }}
      </p>
    }
    <!-- Linha simples da evolução do PL nos anos da janela, com o primeiro e o último ano embaixo. -->
    <app-pit-sparkline [series]="netWorthSeries()" />
  </div>

  <div class="pit-kpi">
    <p class="pit-kpi__label">Dívidas e ônus reais</p>
    @if (indicators().debts) {
      <p class="pit-kpi__value">{{ money(indicators().debts) }}</p>
      @if (indicators().debtsOverNetWorth !== null) {
        <!-- Cor do nível do ponto de dívidas sobre o patrimônio (vermelho em Crítico, amarelo em Atenção). -->
        <p
          class="pit-kpi__note"
          [class.pit-negative]="debtsLevel() === 'critico'"
          [class.pit-warning]="debtsLevel() === 'atencao'">
          {{ ratio(indicators().debtsOverNetWorth) }} do PL
        </p>
      }
      <!-- Barra dívidas ÷ PL: valor e faixas vêm do backend; a tela só desenha. -->
      <app-pit-debt-bar
        [ratio]="indicators().debtsOverNetWorth"
        [limits]="indicators().debtsOverNetWorthLimits"
        [level]="debtsLevel()" />
    } @else {
      <p class="pit-kpi__value pit-kpi__value--muted">Nenhuma dívida declarada</p>
    }
  </div>

  <div class="pit-kpi">
    <p class="pit-kpi__label" title="Renda que sobra após o crescimento patrimonial">
      Renda que sobra
    </p>
    @if (incomeResult() !== null) {
      <p class="pit-kpi__value" [class.pit-negative]="incomeResult()! < 0">
        {{ money(incomeResult(), true) }}
      </p>
      <span
        class="pit-tag kpi__tag"
        [class.pit-tag--success]="incomeResult()! >= 0"
        [class.pit-tag--danger]="incomeResult()! < 0">
        {{ incomeResult()! >= 0 ? 'Compatível' : 'A descoberto' }}
      </span>
      <p
        class="pit-kpi__note"
        [class.pit-positive]="incomeResult()! >= 0"
        [class.pit-negative]="incomeResult()! < 0">
        {{
          incomeResult()! >= 0
            ? 'Renda explica o crescimento do PL'
            : 'Acréscimo patrimonial a descoberto'
        }}
      </p>
    } @else {
      <p class="pit-kpi__value pit-kpi__value--muted">Sem declaração completa</p>
      <p class="pit-kpi__note">O teste precisa da declaração completa, não só do recibo</p>
    }
  </div>

  <div class="pit-kpi">
    <p class="pit-kpi__label">Capacidade livre de garantia</p>
    @if (indicators().policyDefined) {
      <p class="pit-kpi__value">{{ money(indicators().freeCollateral) }}</p>
      @if (indicators().restrictedCollateral) {
        <p class="pit-kpi__note">{{ money(indicators().restrictedCollateral) }} com restrição</p>
      }
    } @else {
      <p class="pit-kpi__value">—</p>
      <!-- Quem cuida da política (ADMIN) vai direto para a Parametrização; os demais leem o motivo. -->
      <a *appHasRole="'ADMIN'" class="pit-link kpi__link" [routerLink]="parametrizationRoute"
        >Definir política de garantias</a
      >
      <p class="pit-kpi__note">sem política definida</p>
    }
  </div>
</section>
